module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_chapel@3x-c81ea1910c54a4261960c827e6c3d625.webp";